import React, { Component } from 'react';
import classNames from 'classnames';
import { values } from 'lodash';
//import queryString from 'query-string';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';

import { MOD_STATE } from '../../../utils/constants';

import Error from '../../Error/Error';
import ModderItem from '../../ModderItem/ModderItem';
import Toggle from '../../Toggle/Toggle';

import { COMMON_ERROR } from '../../../translations';

import { SEARCH_RESULT_MODS } from './translations';

import styles from './ModeratorPanel.module.css';


export default class ModeratorPanel extends Component {
  static propTypes = {
    filtered: PropTypes.shape({
      draft: PropTypes.number,
      review: PropTypes.number,
      published: PropTypes.number,
      rejected: PropTypes.number,

      filterParams: PropTypes.shape({
        ordering: PropTypes.string,
        type: PropTypes.oneOf(values(MOD_STATE)),
      }).isRequired,

      isError: PropTypes.bool.isRequired,
      isFetching: PropTypes.bool.isRequired,
      isFetchedAll: PropTypes.bool.isRequired,
      count: PropTypes.number.isRequired,
      items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        state: PropTypes.number,
        mod: PropTypes.shape({
          id: PropTypes.number.isRequired,
          cover: PropTypes.string,
          mark: PropTypes.number,
          modVersion: PropTypes.string,
          title: PropTypes.string.isRequired,
          versions: PropTypes.arrayOf(PropTypes.shape({
              createdAt: PropTypes.string.isRequired,
              downloadUrl: PropTypes.string,
              id: PropTypes.number.isRequired,
              versionFileOriginalName: PropTypes.string,
              versionFileSize: PropTypes.number,
          })).isRequired,
        }),
        isUpdated: PropTypes.bool,
        isNew: PropTypes.bool,
      })).isRequired,
    }),

    location: ReactRouterPropTypes.location.isRequired,

    fetchItemsAdminPanel: PropTypes.func.isRequired,

    onIncrementDownloadCount: PropTypes.func.isRequired,
    onPublished: PropTypes.func.isRequired,
    onRejected: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      filterParameter: -1,
      filterOrdering: '-default',
      isFiltered: false,
    }
  }

  componentDidMount() {
    this.props.fetchItemsAdminPanel(this.getFilterParams(this.props))
  }

  getFilterParams(props) {
    //const queryStrings = queryString.parse(props.filtered.filterParams)
    const type = props.filtered.filterParams['type']//keys(queryStrings)[0]
    
    return {
        //argument: queryStrings[type],
        //ordering: queryStrings.ordering,
        type,
    }
  }

  handleOrderingChanged = (ordering) => {
    let filterParameter = MOD_STATE.DEFAULT
    if (ordering === '-in_review') {
      filterParameter = MOD_STATE.IN_REVIEW
    } else if (ordering === '-published_update_in_review') {
      filterParameter = MOD_STATE.PUBLISHED_UPDATE_IN_REVIEW
    } else if (ordering === '-rejected') {
      filterParameter = MOD_STATE.REJECTED
    } else if (ordering === '-published_update_rejected') {
      filterParameter = MOD_STATE.PUBLISHED_UPDATE_REJECTED
    } else if (ordering === '-hidden') {
      filterParameter = MOD_STATE.HIDDEN
    } else if (ordering === '-draft') {
      filterParameter = MOD_STATE.DRAFT
    }
    
    const filterParams = {
      //...this.props.filtered.filterParams.type,
      type: filterParameter,
      ordering,
    }
    
    this.props.fetchItemsAdminPanel(filterParams)
    this.setState({filterParameter: filterParameter, filterOrdering: ordering, isFiltered: !this.state.isFiltered})
  }

  renderFilter = () => {
    const classNameFilter = classNames(styles.filter_, {
      [styles.isDisabled]: this.props.filtered.isDisabled,
    })

    return (
      <div className={classNameFilter} title="Фильтр по дате создания">
        <Toggle
          checkedItem={this.state.filterOrdering}
          isDisabled={false} //{this.props.filtered.items.length === 0}
          items={[
            { // -1
              value: "-default",   // -published
              caption: "Все" // Опубликован
            },
            { // 0
              value: "-in_review",
              caption: "На рассмотрении"
            },
            { // 1
              value: "-published_update_in_review",
              caption: "Обновление на рассмотрении"
            },
            { // 2
              value: "-rejected",
              caption: "Отклонен"
            },
            { // 3
              value: "-published_update_rejected",
              caption: "Обновление отклонено"
            },
            { // 4
              value: "-hidden",
              caption: "Скрыт"
            },
            { // 5
              value: "-draft",
              caption: "Черновик"
            }
          ]}
          onItemChange={this.handleOrderingChanged}
        />
      </div>
    )
  }

  renderItems = () => {
    if (this.props.filtered.isError) {
      return <Error>{COMMON_ERROR}</Error>
    }

    return this.props.filtered.items.length === 0 && !this.props.filtered.isFetching ? (
      <Error>{SEARCH_RESULT_MODS}</Error>
    ) : (
      <div className={classNames(styles.boxes, "jsGridView")}>
          {/* {this.props.filtered.items.map((item)) => { this.renderItem(item)) }} */}
          {this.props.filtered.items.map((item) => this.renderItem(item))}
      </div>
    )
  }

  renderItem = (item) => {
      return (
        <ModderItem
          isNew={item.isUpdated}
          isUpdated={item.isUpdated}
          mod={item.mod}
          key={item.id}
          id={item.id}
          fetchItems={this.props.fetchItemsAdminPanel}
          onIncrementDownloadCount={this.props.onIncrementDownloadCount} 
          onPublished={this.props.onPublished}
          onRejected={this.props.onRejected} 
        />
      )
  }

  render() {
    return (
      <div>
        {this.renderFilter()}

        {this.renderItems()}
      </div>
    )
  }
}
